module.exports = __webpack_public_path__ + "media/images/lb/665-2de3d8908d4353cead91c4af502964a0.svg";